import * as React from "react";
import type { SVGProps } from "react";
const SvgSheetWithDollarNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={77}
    height={66}
    fill="none"
    viewBox="0 0 77 66" {...props}
  >
    <path
      fill="url(#sheet-with-dollar-new_svg__a)"
      d="M74.81 48.543h-4.338c-.759 0-1.47.403-1.873 1.066l-1.28 2.11a2.73 2.73 0 0 1-2.299 1.303h-3.626c-.664 0-1.28.309-1.66.854l-1.8 2.489a2.1 2.1 0 0 1-1.826.83l-3.982-.356a2.32 2.32 0 0 0-2.062.9L48.12 60.3a3.23 3.23 0 0 1-2.56 1.28h-4.455a1.76 1.76 0 0 0-1.565.995l-1.422 3.153a9.4 9.4 0 0 1-3.721-1.47 77 77 0 0 1-5.902-4.574c-3.626-3.129-7.846-7.372-11.993-12.894C9.178 36.952 3.963 27.163 1.356 21.854a3.907 3.907 0 0 1 2.3-5.428l10.404-3.365 13.558-4.41 6.613-2.132a4.7 4.7 0 0 1 5.38 1.872c2.394 3.603 6.969 10.192 13.63 18.512.284.355.568.734.876 1.09.024.047.071.095.095.119 7.063 8.722 14.98 15.5 19.673 19.175.45.355.758.782.924 1.256"
      opacity={0.6}
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeMiterlimit={10}
      strokeWidth={0.698}
      d="M76.042 43.259h-4.338c-.758 0-1.469.402-1.872 1.066l-1.28 2.11a2.73 2.73 0 0 1-2.299 1.303h-3.626c-.664 0-1.28.308-1.66.854l-1.8 2.488a2.1 2.1 0 0 1-1.826.83l-3.982-.356a2.32 2.32 0 0 0-2.062.901l-1.944 2.56a3.23 3.23 0 0 1-2.56 1.28h-4.456c-.663 0-1.28.403-1.564.995l-1.422 3.153a9.4 9.4 0 0 1-3.721-1.47 77 77 0 0 1-5.902-4.574c-3.626-3.129-7.846-7.372-11.993-12.894C10.387 31.668 5.196 21.879 2.589 16.57a3.907 3.907 0 0 1 2.299-5.428l10.405-3.366 13.558-4.408 6.613-2.133a4.7 4.7 0 0 1 5.38 1.872c2.394 3.603 6.969 10.192 13.629 18.512.285.355.569.734.877 1.09.024.047.071.095.095.118 7.063 8.723 14.98 15.501 19.673 19.175.45.356.758.783.924 1.257Z"
    />
    <path
      fill="url(#sheet-with-dollar-new_svg__b)"
      d="m19.891 32.615 2.18 2.323 22.376-9.196-2.205-2.134z"
    />
    <path
      fill="url(#sheet-with-dollar-new_svg__c)"
      d="M48.86 22.896c.029-.89-.882-1.64-2.033-1.676-1.152-.037-2.108.655-2.136 1.545s.883 1.64 2.034 1.677c1.152.036 2.108-.656 2.136-1.546"
    />
    <path
      fill="url(#sheet-with-dollar-new_svg__d)"
      d="m23.825 37.359 2.18 2.322 22.376-9.196-2.205-2.157z"
    />
    <path
      fill="url(#sheet-with-dollar-new_svg__e)"
      d="M52.8 27.625c.028-.89-.883-1.64-2.035-1.677-1.151-.036-2.107.656-2.135 1.546s.883 1.64 2.034 1.676 2.108-.656 2.136-1.545"
    />
    <path
      fill="url(#sheet-with-dollar-new_svg__f)"
      d="m28.116 41.74 2.18 2.322 22.376-9.173-2.205-2.157z"
    />
    <path
      fill="url(#sheet-with-dollar-new_svg__g)"
      d="M57.08 32.005c.028-.89-.883-1.64-2.035-1.677-1.15-.036-2.107.656-2.135 1.545-.028.89.883 1.64 2.034 1.677 1.152.036 2.108-.656 2.136-1.545"
    />
    <path
      fill="#00217B"
      d="M27.619 12.35c-.403-.45-.925-.71-1.589-.806-.663-.095-1.374.024-2.085.356s-.877.474-1.162.782-.45.616-.498.948.048.64.261.948.308.356.522.474c.213.119.45.19.734.237.261.048.57.048.877.024.309 0 .664-.071 1.02-.119l1.28-.237c.45-.07.853-.142 1.256-.166.403-.023.782 0 1.137.048.356.047.664.142.949.308.284.142.521.356.734.64.285.403.403.83.356 1.256-.048.45-.26.854-.616 1.256-.38.403-.901.759-1.589 1.067a5.8 5.8 0 0 1-1.872.498c-.593.047-1.138 0-1.635-.19-.498-.166-.901-.45-1.21-.806l.64-.284q.391.462.996.64c.403.118.83.166 1.328.118.474-.047.971-.19 1.47-.403.497-.213.97-.521 1.279-.853s.498-.663.545-1.02c.048-.355-.047-.686-.284-1.018s-.45-.45-.735-.57c-.308-.118-.664-.165-1.09-.165s-.925.071-1.47.166l-1.375.26c-.924.166-1.706.19-2.346.048-.64-.119-1.138-.427-1.47-.9-.332-.475-.403-.806-.332-1.233.048-.427.261-.83.617-1.209.355-.38.83-.711 1.422-.972a5.5 5.5 0 0 1 1.778-.45c.592-.024 1.114.047 1.611.237.498.19.877.474 1.186.83l-.617.26zm1.967 7.917-6.85-9.505.474-.213 6.85 9.504z"
    />
    <defs>
      <linearGradient
        id="sheet-with-dollar-new_svg__a"
        x1={0.953}
        x2={74.809}
        y1={35.981}
        y2={35.981}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
      <linearGradient
        id="sheet-with-dollar-new_svg__b"
        x1={55.081}
        x2={4.472}
        y1={0.791}
        y2={63.536}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={0.2} stopColor="#98CBFF" stopOpacity={0.8} />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="sheet-with-dollar-new_svg__c"
        x1={60.816}
        x2={10.206}
        y1={5.439}
        y2={68.208}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="sheet-with-dollar-new_svg__d"
        x1={59.776}
        x2={9.166}
        y1={4.57}
        y2={67.339}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="sheet-with-dollar-new_svg__e"
        x1={65.496}
        x2={14.887}
        y1={9.218}
        y2={71.964}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="sheet-with-dollar-new_svg__f"
        x1={64.517}
        x2={13.908}
        y1={8.414}
        y2={71.159}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="sheet-with-dollar-new_svg__g"
        x1={70.219}
        x2={19.61}
        y1={13.067}
        y2={75.812}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#98CBFF" />
        <stop offset={1} stopColor="#98CBFF" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgSheetWithDollarNew;
